import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PrescriptionCard from '../components/PrescriptionCard';
import bloodService from '../services/blood';

function buildBloodTestSummaryFromReport(selected) {
  if (!selected) return null;
  return {
    orderId: String(
      selected?.orderId || selected?.orderApprovalId || selected?.order_id || ''
    ).trim(),
    testType: String(selected?.header?.type || '').trim(),
    testDate: String(selected?.header?.testDate || '').trim(),
    resultDate: String(selected?.header?.resultDate || '').trim(),
  };
}

export default function BloodTestPrescriptionPage() {
  const location = useLocation();
  const [summaryPrefill, setSummaryPrefill] = useState(
    location.state?.summaryPrefill || null
  );
  const [bloodTestSummary, setBloodTestSummary] = useState(
    location.state?.bloodTestSummary || null
  );
  const [reportContext, setReportContext] = useState({
    recordId: String(location.state?.recordId || '').trim(),
    bloodTestId: String(location.state?.bloodTestId || '').trim(),
  });

  useEffect(() => {
    let cancelled = false;
    const loadSummaryForPrefill = async () => {
      const hasPrefill = Boolean(location.state?.summaryPrefill);
      const hasBloodSummary = Boolean(location.state?.bloodTestSummary);

      if (hasPrefill && hasBloodSummary) return;

      try {
        const reports = await bloodService.fetchBloodSummary();
        if (cancelled || !Array.isArray(reports) || reports.length === 0) return;

        const targetRecordId = String(location.state?.recordId || '').trim();
        const matched = targetRecordId
          ? reports.find((r) => String(r?.recordId || '').trim() === targetRecordId)
          : null;
        const selected = matched || reports[0];

        if (!hasPrefill) {
          setSummaryPrefill(selected?.prescriptionPrefill || null);
        }
        if (!hasBloodSummary) {
          setBloodTestSummary(buildBloodTestSummaryFromReport(selected));
        }
        setReportContext({
          recordId: String(selected?.recordId || targetRecordId || '').trim(),
          bloodTestId: String(
            selected?.bloodTestId || selected?.blood_test_id || ''
          ).trim(),
        });
      } catch (_) {
        // Keep form usable even when summary fetch fails.
      }
    };

    loadSummaryForPrefill();
    return () => {
      cancelled = true;
    };
  }, [location.state]);

  return (
    <div className="min-w-screen min-h-screen bg-[#F9F5F2] py-12 px-4">
      <div className="w-full flex flex-col items-center mb-6 md:mb-10">
        <h1 className="text-[#2B3133] font-libreBaskerville text-[32px] md:text-[44px] leading-[1.1em]">
          Prescription
        </h1>
      </div>
      <PrescriptionCard
        summaryPrefill={summaryPrefill}
        reportContext={reportContext}
        bloodTestSummary={bloodTestSummary}
      />
    </div>
  );
}
